<div class="pdrh-actions">
  <p-button label="Baixar template Excel" icon="pi pi-download" severity="secondary" [outlined]="true"
    [loading]="isDownloadingTemplate" [disabled]="!empresaId || isDownloadingTemplate"
    (onClick)="downloadTemplate()"></p-button>
  <p-button label="Carregar necessidade" icon="pi pi-upload" [disabled]="!empresaId"
    (onClick)="openImport()"></p-button>
</div>

<p-dialog header="Carregar plano de necessidades" [(visible)]="showImport" [modal]="true"
  [closable]="!isImporting && !isReadingExcel" [closeOnEscape]="!isImporting && !isReadingExcel"
  [dismissableMask]="false" [style]="{ width: '82vw', maxWidth: '1120px' }" styleClass="necessidades-import-dialog"
  appendTo="body" (onHide)="resetImport()">
  <div class="import-content">
    <div class="import-guidance">
      <div class="guidance-icon"><i class="pi pi-file-excel"></i></div>
      <div>
        <strong>Importe o template preenchido</strong>
        <p>Selecione o ficheiro Excel, confira as 11 colunas e todas as linhas abaixo e só depois faça a submissão.</p>
      </div>
    </div>

    @if (importError) {
    <div class="import-error-alert">
      <div class="alert-header">
        <i class="pi pi-exclamation-triangle alert-icon"></i>
        <div class="alert-title-group">
          <strong>{{ importError.summary }}</strong>
          <span>Corrija os erros indicados abaixo no ficheiro Excel e tente novamente.</span>
        </div>
      </div>
      @if (importError.details.length) {
      <ul class="alert-details-list">
        @for (detail of importError.details; track $index) {
        <li>{{ detail }}</li>
        }
      </ul>
      }
    </div>
    }

    <label class="excel-dropzone" [class.dragging]="isDraggingExcel" [class.has-file]="selectedFile"
      (dragover)="onExcelDragOver($event)" (dragleave)="onExcelDragLeave($event)" (drop)="onExcelDrop($event)">
      <input type="file"
        accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
        (change)="onExcelInputChange($event)" [disabled]="isReadingExcel || isImporting" />

      @if (isReadingExcel) {
      <i class="pi pi-spinner pi-spin dropzone-icon"></i>
      <strong>A ler o ficheiro Excel...</strong>
      <span>Aguarde enquanto preparamos a pré-visualização.</span>
      } @else if (selectedFile) {
      <i class="pi pi-check-circle dropzone-icon success"></i>
      <strong>{{ selectedFile.name }}</strong>
      <span>{{ formatFileSize(selectedFile.size) }} · Clique ou arraste outro ficheiro para substituir</span>
      } @else {
      <i class="pi pi-cloud-upload dropzone-icon"></i>
      <strong>Arraste o Excel para esta área ou clique para selecionar</strong>
      <span>Formatos permitidos: .xlsx e .xls · Tamanho máximo: 10 MB</span>
      }
    </label>

    @if (previewRows.length) {
    <div class="preview-section">
      <div class="preview-header">
        <div>
          <span class="preview-title">Pré-visualização das necessidades</span>
          <span class="preview-subtitle">Folha “{{ previewSheetName }}”</span>
        </div>
        <span class="row-count">{{ previewRows.length }} linha(s)</span>
      </div>

      <p-table [value]="previewRows" [paginator]="previewRows.length > 8" [rows]="8" [rowsPerPageOptions]="[8, 15, 30]"
        [scrollable]="true" scrollHeight="360px" styleClass="excel-preview-table">
        <ng-template pTemplate="header">
          <tr>
            <th class="row-number-column">#</th>
            <th *ngFor="let header of previewHeaders">{{ header }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
          <tr>
            <td class="row-number-column">{{ rowIndex + 1 }}</td>
            <td *ngFor="let value of row" [title]="formatPreviewValue(value)">
              {{ formatPreviewValue(value) }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="import-footer">
      <p-button label="Cancelar" severity="secondary" [outlined]="true" [disabled]="isImporting || isReadingExcel"
        (onClick)="showImport = false"></p-button>
      <p-button [label]="previewRows.length ? 'Submeter ' + previewRows.length + ' linha(s)' : 'Submeter necessidades'"
        icon="pi pi-check" [loading]="isImporting"
        [disabled]="!selectedFile || !previewRows.length || isReadingExcel || isImporting"
        (onClick)="submitExcel()"></p-button>
    </div>
  </ng-template>
</p-dialog>